// phpへのフェッチURLを指定
// :3000はbunで開発サーバー立ち上げ時はステージングサイトのものを利用（CORSあるので開発時はCORSを解除します）
// その他のステージング、本番、開発(XAMPP)では"./apiReqPHP"でOK
export const fetchURL = location.href.includes(":3000") ? "http://auction-zero.com/apiReqPHP" : "./apiReqPHP";
// export const fetchURL = "http://localhost/apiReqPHP";
// export const fetchURL = "./apiReqPHP";
